export const PIM_CONFIG_REQUEST_START = "PIM_CONFIG_REQUEST_START";
export const PIM_CONFIG_REQUEST_SUCCESS = "PIM_CONFIG_REQUEST_SUCCESS";
export const PIM_CONFIG_REQUEST_FAIL = "PIM_CONFIG_REQUEST_FAIL";

export const SET_SELECTED_LOCATION = "SET_SELECTED_LOCATION";

export const FETCH_ORDER_VENDOR_START = "FETCH_ORDER_VENDOR_START";
export const FETCH_ORDER_VENDOR_SUCCESS = "FETCH_ORDER_VENDOR_SUCCESS";
export const FETCH_ORDER_VENDOR_FAIL = "FETCH_ORDER_VENDOR_FAIL";
